import React from "react";
import Link from "next/link";
import { CALENDLY_URL } from "@/common/site.config";
import {
  LandingSection,
  SectionHeader,
} from "./landing/landing-ui";

const principles = [
  {
    title: "Workflow first",
    description:
      "We design from the job to be done: inputs, systems, handoffs, and owners. Models come after the process is clear.",
  },
  {
    title: "Grounded and reviewable",
    description:
      "Answers and actions stay tied to approved sources and tool calls. Exception paths keep people in control where it matters.",
  },
  {
    title: "Built to be owned",
    description:
      "Documentation, monitoring, and handoff are part of delivery. Your team should be able to operate what we ship.",
  },
];

function HumanFirstAiPhilosophy() {
  return (
    <LandingSection muted>
      <div className="grid gap-10 lg:grid-cols-12 lg:items-start">
        <div className="lg:col-span-5">
          <SectionHeader
            align="left"
            title="How we decide what to build"
            lead="Three commitments that keep projects practical and production-ready."
          />
          <Link
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="landing-btn-primary mt-8"
          >
            Talk through your workflow
          </Link>
        </div>
        <div className="grid gap-4 lg:col-span-7">
          {principles.map((item, index) => (
            <div
              key={item.title}
              className="rounded-2xl border border-line bg-surface p-6"
            >
              <p className="text-sm font-semibold text-ink-soft">
                {String(index + 1).padStart(2, "0")}
              </p>
              <h3 className="mt-2 text-lg font-semibold text-ink">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-muted">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </LandingSection>
  );
}

export default HumanFirstAiPhilosophy;
